import IconCard, { CardDescription, CardValue } from "components/company/cards/IconCard";
import CalendarIcon from "components/svg/CalendarIcon";
import getYear from "date-fns/getYear";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { palette } from "lib/miolo";
import parseDateYmd from "lib/utils/parseDateYmd";
import { FormattedMessage } from "react-intl";

interface IRegistrationDateOrIPOCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment | IAmericanCompanyIssuerTopLevelFragment;
}

export default function RegistrationDateOrIPOCard({ issuer }: IRegistrationDateOrIPOCardProps) {
  const isBrazilianIssuer = issuer.__typename === "BrazilianCompanyIssuer";
  const isAmericanIssuer = issuer.__typename === "AmericanCompanyIssuer";

  if (isBrazilianIssuer && !issuer.cvmRegistrationDate) {
    return null;
  }

  if (isAmericanIssuer && !issuer.ipoDate) {
    return null;
  }

  const date = isBrazilianIssuer ? issuer.cvmRegistrationDate : issuer.ipoDate;
  const diffInYears = getYear(new Date()) - parseFloat(date);

  return (
    <IconCard primaryColor={palette.oceanGreen} secondaryColor={palette.grannyApple} icon={<CalendarIcon />}>
      {diffInYears >= 1 ? (
        <div className="flex items-baseline">
          <CardValue>{isBrazilianIssuer ? getYear(parseDateYmd(date)) : parseFloat(date)}</CardValue>

          <div className="ml-2">
            <small className="font-aeonik font-medium italic text-gray-500">
              <FormattedMessage
                defaultMessage="(há {years, plural, one {# ano} other {# anos}})"
                id="JVlc/m"
                description="IPO card"
                values={{
                  years: diffInYears,
                }}
              />
            </small>
          </div>
        </div>
      ) : (
        <CardValue>{getYear(parseDateYmd(date))}</CardValue>
      )}

      <CardDescription>
        {isBrazilianIssuer ? (
          <FormattedMessage defaultMessage="Listagem na CVM" description="IPO card" id="Mrhc42" />
        ) : (
          "IPO"
        )}
      </CardDescription>
    </IconCard>
  );
}
